import React from "react"
import { Container, Row, Col, Button } from "react-bootstrap"
import FlatSection from "../components/FlatSection"
import WhiteLogo from "../images/logo_white.svg"
import HeroPic from "../images/hero.png"
import { Link } from "gatsby"
import { useTranslation } from "react-i18next"

export default function Home() {
  const { t } = useTranslation()
  return (
    <section className="header-area bg-light">
      <div className="header-hero" id="home">
        <div className="header-hero-img">
          <img src={HeroPic} alt="A boy and a girl reading books" />
        </div>
        <div className="hero-shape-default"></div>
        <Container>
          <Row>
            <Col sm={6}>
              <div className="header-hero-content">
                <img
                  src={WhiteLogo}
                  alt="IDF"
                  className="white-logo"
                  loading="lazy"
                />
                {/* <h1>{t("Welcome to React")}</h1> */}
                <h1 className="title-section">Empowering Education</h1>
                <h3 className="description-section">{t("empowering")}</h3>
                <Button
                  as={Link}
                  to="/education"
                  className="main-btn"
                  role="button"
                >
                  {t("fWhyEducation")}
                </Button>
              </div>
            </Col>
          </Row>
          <Row className="vision-mission" id="vision">
            <Col sm={8} className="mb-70">
              <div className="vision-content mt-100">
                <h1 className="title-section">Visi & Misi</h1>
                <h6 className="sub-title mb-20">InfraDigital Foundation</h6>
                <p className="description-section">{t("vision")}</p>
              </div>
            </Col>
          </Row>
          <FlatSection />
          <Row className="justify-content-end mt-4 mb-5">
            <Col sm={6} className="text-right">
              <Button as={Link} to="/about" className="main-btn " role="button">
                {t("hBtn")}
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  )
}
